// ====================================================================================
// headerSearch.module
// ====================================================================================
import $ from "jquery";

export const init = () => {
  let attempts = 0;
  let resInterval = null;

  const $header = $("header");
  const $bottomNav = $(".header__bottom-nav");
  const bottomNavDetails = { top: 0 };

  if ($bottomNav.length > 0) {
    bottomNavDetails.top = $bottomNav.offset().top;
  }

  const closeSearch = (num) => {
    // alert(`closeSearch ${num}`);
    $(".form.form-header-search")
      .slideUp(function () {
        $header.css("height", "");
      })
      .removeClass("active");
    if ($bottomNav.length > 0) $bottomNav.css("top", "");
  };

  // if document.ready needed
  const whenComplete = () => {
    if (++attempts > 30) return;
    if (document.readyState === "complete") {
      $header.find('[data-js="open-search"]').on("click", function (e) {
        let $searchForm = $(".form.form-header-search");
        if ($searchForm.hasClass("active")) {
          closeSearch("1");
        } else {
          if ($bottomNav.length > 0) $bottomNav.hide();
          $searchForm
            .slideDown(100, function () {
              if ($bottomNav.length > 0) {
                let headerHeight = $header.outerHeight();
                $bottomNav.css("top", `${headerHeight}px`);
                $bottomNav.show();
              }
            })
            .addClass("active");
          $header.css("height", "auto");
        }
      });

      $header
        .find(".form.form-header-search .btn--close")
        .on("click", () => closeSearch("2"));

      window.addEventListener("resize", function (e) {
        // if (window.innerWidth < 991) closeSearch("3");
        if ($bottomNav.length > 0) {
          if (resInterval) clearInterval(resInterval);
          resInterval = setInterval(function () {
            bottomNavDetails.top = $bottomNav.offset().top;
          }, 400);
        }
      });
    } else {
      setTimeout(() => whenComplete(), 400);
    }
  };
  whenComplete();
};
